'use strict';

const base = require('core/components/slider');

function getUpdatedSlideItems (images, assets, videos, isThumbnail, zoom = true) {
    var slideItems = [];

    images['large'].forEach(image => {
        var $slideElement = $('<div></div>').attr('class', 'slide');
        var $imageElement = $('<img/>');

        if (!isThumbnail) {
            $slideElement.attr('data-zoom-image', images['hi-res'].length ? images['hi-res'][image.index].url : images['large'][image.index].url);
        }

        $imageElement.attr({
            'src': image.url,
            'alt': image.alt + ' image number ' + (parseInt(image.index) + 1).toFixed(0),
            'class': 'd-block img-fluid',
            'itemprop': 'image'
        });

        $slideElement.append($imageElement);
        slideItems.push($slideElement[0]);
    });

    // base.getPDPGalleryAssetSlides(slideItems, assets, isThumbnail);

    if (videos) {
        getVideoSlides(slideItems, videos, isThumbnail);
    }

    if (!zoom) {
        slideItems.forEach(function (slide) {
            $(slide).addClass('no-zoom');
        });
    }

    return slideItems;
}

function getVideoSlides(slideItems, videos, isThumbnail) {
    if (isThumbnail) {
        videos.thumbnails.forEach((thumbnail, idx) => {
            if (videos.URLs[idx]) {
                var $slideElement = $('<div></div>').attr('class', 'slide video-container');
                var $imageElement = $('<img/>');
                var $videoButton = $('<span class="video-thumbnail-button"></span>');

                $imageElement.attr({
                    'src': thumbnail,
                    'alt': 'Image number ' + (parseInt(thumbnail.index) + 1).toFixed(0),
                    'class': 'd-block img-fluid',
                    'itemprop': 'image'
                });

                $slideElement.append($imageElement);
                $slideElement.append($videoButton);

                slideItems.push($slideElement[0]);
            }
        });
    } else {
        videos.URLs.forEach((videoURL, idx) => {
            if (videos.thumbnails[idx]) {
                var $slideElement = $('<div></div>').attr('class', 'slide no-zoom');
                var videoElement = $(videoURL);
                var videoContainer = $('<div></div>').attr('class', 'video-container aspect-ratio-16-9');
                var videoPlayer = $('<div></div>').attr('class', 'video-player');

                videoPlayer.append(videoElement);
                videoContainer.append(videoPlayer);
                $slideElement.append(videoContainer);

                slideItems.push($slideElement[0]);
            }
        })
    }

    return slideItems;
}

base.getUpdatedSlideItems = getUpdatedSlideItems;

module.exports = base;
